import { Validators } from '../../../../../../utils/validators';
import { FormModel } from '../../../../../../components/Form';
import dayjs from 'dayjs';

export const AddEditHighDemandDateForm = (strings: any): FormModel[] => {
  const today = dayjs(new Date());
  return [
    {
      label: strings.venueConfig_general_highDemandStart,
      value: '',
      size: 'medium',
      autoFocus: true,
      type: 'date',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: '',
      field: 'highDemandStartDate',
      validators: [{ check: Validators.validateMandatoryField }],
      responsive: { xs: 12 },
      required: true,
      minDate: today,
    },
    {
      label: strings.venueConfig_general_highDemandEnd,
      value: '',
      size: 'medium',
      autoFocus: false,
      type: 'date',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: '',
      field: 'highDemandEndDate',
      validators: [{ check: Validators.validateMandatoryField }],
      responsive: { xs: 12 },
      required: true,
      minDate: today,
    },
    {
      label: strings.venueConfig_general_highDemandName,
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: '',
      field: 'highDemandCategory',
      validators: [{ check: Validators.validateString }],
      responsive: { xs: 12 },
      required: false,
    },
  ];
};
